import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import FeaturedSection from './components/FeaturedSection';
import LatestSection from './components/LatestSection';
import RankingSection from './components/RankingSection';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebPage",
          "name": "韩国漫画在线阅读_最新免费的漫画大全-韩漫网站",
          "description": "韩漫网站支持韩国漫画在线阅读，提供最新免费漫画大全，资源丰富画质佳，是您休闲娱乐的好去处。",
          "url": "https://www.hanmanwang.com/",
          "inLanguage": "zh-CN",
          "isPartOf": {
            "@type": "WebSite",
            "name": "韩漫网",
            "url": "https://www.hanmanwang.com/"
          },
          "about": {
            "@type": "Thing",
            "name": "韩国漫画在线阅读",
            "description": "提供最新免费韩国漫画在线阅读服务"
          }
        }) }} />
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "韩漫网",
          "url": "https://www.hanmanwang.com/",
          "description": "韩漫网站支持韩国漫画在线阅读，提供最新免费漫画大全，资源丰富画质佳，是您休闲娱乐的好去处。",
          "contactPoint": {
            "@type": "ContactPoint",
            "email": "contact@hanmanwang.com",
            "contactType": "customer service",
            "availableLanguage": ["Chinese"]
          }
        }) }} />
        <CategoryNav />
        <FeaturedSection />
        <LatestSection />
        <RankingSection />
      </main>
      <Footer />
    </>
  );
}